export const getters = {
  ocrBoxInfo: state => state.ocrBoxInfo,
  businessLicenseImage: state => state.businessLicenseImage,
  businessLicenseInfo: state => state.businessLicenseInfo,
  currentAreaCode: state => state.currentAreaCode,
  userInfo: state => state.userInfo
};
